export default __webpack_public_path__ + "static/media/Rachna Sizemore Heizer.ab0dffd1.jpg";